import { FC, useRef } from 'react';
import { Flex } from 'antd';
import { DataTable, ModalDialog, UploadButton } from '../..';
import { IProps } from './type';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { IFile } from '../../../types';
import { getColumns } from './columns';
import { useAppSelector } from '../../../store';

dayjs.extend(customParseFormat);

const AdditionalFileModal: FC<IProps> = (props) => {
  const uploadInput = useRef<HTMLInputElement | null>(null);
  const columns = getColumns(props.model, props.handleDeleteFile);
  const permissions = useAppSelector((state) => state.userReducer.permissions);
  const hasAddPermission = permissions.some(
    (permission) =>
      permission.model === props.model && permission.action === 'add',
  );

  return (
    <ModalDialog
      title="Ek Dosya İşlemleri"
      subTitle="Ek Dosya Yükleme, Güncelleme ve Silme İşlemleri"
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        {hasAddPermission && (
          <UploadButton
            fileName={[
              Array.from(props.tempAdditionalFiles ?? [])
                .map((item) => item.name)
                .join(', ') ?? '',
            ]}
            uploadRef={uploadInput}
            onChange={props.handleUploadFile}
          />
        )}
        <DataTable<IFile>
          isSticky={false}
          columns={columns}
          dataSource={props.additionalFiles ?? []}
          isPaginationDisplayed={false}
          isFooterDisplayed={false}
        />
      </Flex>
    </ModalDialog>
  );
};

export default AdditionalFileModal;
